import {
  ApiRemoveDiscountCodeFailedAction,
  ApiRemoveDiscountCodeSucceededAction,
  apiRemoveDiscountCodeFailedType,
  apiRemoveDiscountCodeRequested,
  apiRemoveDiscountCodeSucceededType
} from '@spa/lib/store/api/cart/removeDiscountCodeApi';
import {
  RemoveDiscountCodeRequestedAction,
  removeDiscountCodeFailed,
  removeDiscountCodeSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import convertCartToStateCart from '@spa/lib/converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* removeDiscountCodeFromCartSaga({
  payload: { actionId: requestedActionId, customOrderType, codeId }
}: RemoveDiscountCodeRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiRemoveDiscountCodeRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId,
      codeId
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiRemoveDiscountCodeSucceededAction>(apiRemoveDiscountCodeSucceededType),
      failed: take<ApiRemoveDiscountCodeFailedAction>(apiRemoveDiscountCodeFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const cart = succeeded.payload.result?.cart;

        yield* put(
          removeDiscountCodeSucceeded({
            cart: cart ? convertCartToStateCart(cart) : null,
            customOrderType,
            requestedActionId
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          removeDiscountCodeFailed({
            requestedActionId,
            codeId,
            customOrderType
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default removeDiscountCodeFromCartSaga;
